import { NgModule } from "@angular/core";
import { FormLegendComponent } from "./form-legend.component";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  imports: [NgbPopoverModule, MatIconModule],
  declarations: [FormLegendComponent],
  exports: [FormLegendComponent]
})
export class FormLegendModule {}